import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";

export interface Issue {
  id: string;
  type: "warning" | "error";
  description: string;
  retryData?: {
    endpointName: string;
    originalArgs: string;
    requestId: string;
  };
}

export type State = {
  errorDescriptions: { [requestId: string]: string };
  issues: Issue[];
};

const issuesSlice = createSlice({
  name: "issues",
  initialState: {
    errorDescriptions: {} as { [requestId: string]: string },
    issues: [],
  },
  reducers: {
    addErrorDescription: (
      state: State,
      action: PayloadAction<{ requestId: string; errorDescription: string }>
    ) => {
      state.errorDescriptions[action.payload.requestId] =
        action.payload.errorDescription;
    },
    updateErrorDescriptionId: (
      state: State,
      action: PayloadAction<{ from: string; to: string }>
    ) => {
      const { from, to } = action.payload;
      if (state.errorDescriptions[from]) {
        state.errorDescriptions[to] = state.errorDescriptions[from];
        delete state.errorDescriptions[from];
      }
    },
    removeErrorDescriptionById: (
      state: State,
      action: PayloadAction<string>
    ) => {
      delete state.errorDescriptions[action.payload];
    },
    addIssue: (state: State, action: PayloadAction<Issue>) => {
      state.issues.push({ ...action.payload });
    },
    removeIssueById: (state: State, action: PayloadAction<string>) => {
      state.issues = state.issues.filter(
        (issue) => issue.id !== action.payload
      );
    },
  },
});

export const {
  addErrorDescription,
  updateErrorDescriptionId,
  removeErrorDescriptionById,
  addIssue,
  removeIssueById,
} = issuesSlice.actions;

export default issuesSlice.reducer;

export const selectIssues = (state: RootState): Issue[] => state.issues.issues;
